import React from 'react';

const PageNotf = () => {
  return (
      <div>
      <h1>404</h1>
      <h5>Page Not Found</h5>
      <a href="/">Go to Home</a>
    </div>
  );
};

export default PageNotf;

